<template>
  <Button
    v-if="storeUrl"
    :href="loginUrl"
    tag="a"
    width="full"
    :theme="theme"
    @click="stashReturnUrl"
  >
    Continue with Google
  </Button>
</template>

<script>
import Button from "@/components/ButtonV3.vue";
import { stashSsoReturnUrl } from "@/helpers/url.js";

export default {
  name: "GoogleSignOn",
  components: {
    Button,
  },
  props: {
    theme: {
      type: String,
      default: "primary",
    },
    returnUrl: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      storeUrl: process.env.SHOPIFY_SSO_STORE_URL || null,
    };
  },
  computed: {
    resolvedReturnUrl() {
      const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
      });

      return this.returnUrl || params["checkout_url"] || params["return_url"];
    },
    loginUrl() {
      // The return URL is deliberately NOT nested inside `redirect_endpoint`.
      // The broker re-encodes nested query values on its way back, which
      // produced a literal "%2F" in multipass `return_to`. The destination is
      // stashed in sessionStorage on click (see stashReturnUrl) and read back
      // by views/Login.vue on the callback instead.
      return `https://login.ratandboa.com/moas/broker/login/shopify/${this.storeUrl}/account?idpname=google_oauth&redirect_endpoint=/account/login`;
    },
  },
  methods: {
    stashReturnUrl() {
      stashSsoReturnUrl(this.resolvedReturnUrl);
    },
  },
};
</script>
